import React from "react";
import {
  Hero,
  Trending_category,
  NewseLatter,
} from "../../components/component";
import MintsContent from "../../components/cadr-aggregator/mints";
import Meta from "../../components/Meta";

const Home_1 = () => {
  return (
    <main>
      <Meta title="CarbonPump" />
      <Hero />
        {/*  <MintsContent/> */ }
      <Trending_category />
      <NewseLatter />
    </main>
  );
};

export default Home_1;
